import { Text } from '@cinesend/ui-kit'
import { Check, Warning } from '@phosphor-icons/react'
import { useQueries } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import DashboardWidget from '../widget'

const ISSUE_TYPES = [
  { key: 'metadata', label: 'Metadata' },
  { key: 'images', label: 'Images' },
  { key: 'content', label: 'Content' },
]

const setIssuesFilters = (cycleID, type) => {
  try {
    sessionStorage.setItem(
      `table-filters-issues-table-${cycleID}`,
      JSON.stringify({
        search: '',
        filter: { type: [type], status: ['open'] },
        filterChosen: true,
        sorting: { key: 'created_at', direction: 'desc' },
        pagination: { currentPage: 0, rowsPerPage: 25 },
      })
    )
  } catch {
    // Ignore storage failures; navigation still works without the filter.
  }
}

const IssuesSummaryWidget = ({ cycleID, ...widgetProps }) => {
  const { airlineID } = useParams()
  const queries = useQueries({
    queries: ISSUE_TYPES.map((type) => ({
      queryKey: [
        `issues?cycleID=${cycleID}&filter[status]=open&filter[type]=${type.key}&pagination[rowsPerPage]=5&pagination[currentPage]=0`,
      ],
    })),
  })

  const isLoading = queries.some((query) => query.isLoading)
  const error = queries.find((query) => query.isError)?.error
  const onRetry = () => queries.forEach((query) => query.refetch())

  return (
    <DashboardWidget title='Issues summary' isLoading={isLoading} error={error} onRetry={onRetry} {...widgetProps}>
      <ul className='m-0 flex h-full min-h-0 flex-1 list-none flex-col divide-y divide-[color:var(--cs-color-border-subtle)] p-0'>
        {ISSUE_TYPES.map((type, index) => {
          const count = queries[index]?.data?.meta?.total ?? 0
          return (
            <li key={type.key} className='flex min-h-0 flex-1 items-center'>
              <Link
                to={`/airlines/${airlineID}/cycles/${cycleID}/issues`}
                onClick={() => setIssuesFilters(cycleID, type.key)}
                className='flex h-[var(--cs-height-h-10)] w-full items-center justify-between gap-3 rounded-[var(--cs-radius-lg)] px-3 no-underline hover:bg-[var(--cs-color-background-tertiary)]'
              >
                <Text as='span' variant='sm-medium'>
                  {type.label}
                </Text>
                {count === 0 ? (
                  <span className='inline-flex items-center gap-1.5'>
                    <Text as='span' variant='sm' tone='secondary'>
                      No issues
                    </Text>
                    <Check
                      size={20}
                      weight='regular'
                      aria-hidden='true'
                      className='text-[color:var(--cs-color-foreground-success)]'
                    />
                  </span>
                ) : (
                  <span className='inline-flex items-center gap-1.5 text-[color:var(--cs-color-foreground-error)]'>
                    <Text as='span' variant='sm-medium' tone='error'>
                      {count} issues
                    </Text>
                    <Warning size={20} weight='regular' aria-hidden='true' />
                  </span>
                )}
              </Link>
            </li>
          )
        })}
      </ul>
    </DashboardWidget>
  )
}

export default IssuesSummaryWidget
